module.exports = __webpack_public_path__ + "img/dd2_2_scheme.07bd4fd2.svg";